import { ReactNode } from 'react';
import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { getTextTokenPreset, getToken } from '@optimus-web/common';
import { ANIMATION_CURVE, ANIMATION_DURATION } from '@optimus-web/local-tokens';
import { Stack, StackProps } from '../../Stack';

export const BulkActionsContainer = styled(Stack)<{ disabled?: boolean } & StackProps>`
    background-color: ${({ disabled }) =>
        disabled
            ? getToken(TokenName.BACKGROUND_STATIC_FLAT)
            : getToken(TokenName.BACKGROUND_INTERACTIVE_PRIMARY_DEFAULT)};
    border-radius: ${getToken(TokenName.BORDER_RADIUS_100)}px;
    margin: ${getToken(TokenName.SPACING_100)}px ${getToken(TokenName.SPACING_0)};
    padding: ${getToken(TokenName.SPACING_100)}px ${getToken(TokenName.SPACING_200)}px;
    color: ${({ disabled }) =>
        disabled ? getToken(TokenName.TEXT_DISABLED) : getToken(TokenName.TEXT_STATIC_INVERSE)};
    ${getTextTokenPreset('BODY_M')};
    border: ${({ disabled, theme }) =>
        `${getToken(TokenName.BORDER_WIDTH_100)({ theme })}px solid ${
            disabled ? getToken(TokenName.BORDER_DISABLED)({ theme }) : 'transparent'
        }`};
    transition-property: background-color, color;
    transition-timing-function: ${ANIMATION_CURVE.default};
    transition-duration: ${ANIMATION_DURATION.fast}ms;
`;

interface BulkActions {
    leftSide?: ReactNode;
    /* We cannot pass directly an array of items as rightSide prop because of this Storybook issue
     * https://github.com/storybookjs/storybook/pull/19188
     * it crashes the dev server */
    rightSide?: JSX.Element;
    disabled?: boolean;
}

const TableBulkActions = ({ leftSide, rightSide, disabled }: BulkActions) => (
    <BulkActionsContainer
        itemAlignment="center"
        distribution="space-between"
        disabled={disabled}
        aria-disabled={disabled}
    >
        {leftSide || <div />}
        <Stack spacing="100">{rightSide}</Stack>
    </BulkActionsContainer>
);

export default TableBulkActions;
